import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject, Component, OnInit } from '@angular/core';
@Component({
  selector: 'xsr-sales-hint-dialog',
  templateUrl: './sales-hint-dialog.component.html',
  styleUrls: ['./sales-hint-dialog.component.css'],
})
export class SalesHintDialogComponent implements OnInit {
  selectedServiceGroup: any;

  constructor(public dialogRef: MatDialogRef<SalesHintDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}

  onCancel(): void {
    this.dialogRef.close({ cancelled: true });
  }
}
